// extracted by mini-css-extract-plugin
export default {"BodyContainer":"_BodyContainer--zqlWR","BodyContainerText":"_BodyContainerText--ii1XM","WarningIcon":"_WarningIcon--FY3oG","Heading":"_Heading--ZQg21"};